/**
 * Helpers pour les recettes (couleurs, format)
 */

export function getDifficultyColor(difficulty) {
  const colors = {
    Facile: "bg-green-100 text-green-800 border-green-300",
    Moyen: "bg-yellow-100 text-yellow-800 border-yellow-300",
    Difficile: "bg-red-100 text-red-800 border-red-300",
  };
  return colors[difficulty] || "bg-gray-100 text-gray-800 border-gray-300";
}

export function getMatchColor(percentage) {
  if (percentage >= 80) return "bg-green-500";
  if (percentage >= 60) return "bg-yellow-500";
  return "bg-orange-500";
}

export function mealToRecipe(mealDetail) {
  const ingredients = [];
  for (let i = 1; i <= 20; i++) {
    const ing = mealDetail[`strIngredient${i}`];
    const measure = mealDetail[`strMeasure${i}`];
    if (ing && ing.trim()) {
      ingredients.push(`${measure} ${ing}`.trim());
    }
  }
  return {
    id: mealDetail.idMeal,
    title: mealDetail.strMeal,
    description: `${mealDetail.strCategory || ""} - ${mealDetail.strArea || ""}`,
    ingredients: ingredients.join("\n"),
    instructions: mealDetail.strInstructions,
    difficulty: "Moyen",
    image: mealDetail.strMealThumb,
    source: "TheMealDB",
    youtube: mealDetail.strYoutube,
    category: mealDetail.strCategory,
    area: mealDetail.strArea,
  };
}
